import GoogleIcon from '@mui/icons-material/Google';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

interface GoogleSignInButtonProps {
  loading: boolean;
  disabled: boolean;
  onSignIn: () => void;
}

export default function GoogleSignInButton({loading, disabled, onSignIn}: GoogleSignInButtonProps) {
  return (
    <Button
      fullWidth
      variant="contained"
      size="large"
      onClick={onSignIn}
      disabled={disabled}
      data-testid="google-sign-in"
      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <GoogleIcon />}
      sx={{
        py: 1.5,
        fontSize: '1.1rem',
        fontWeight: 600,
        bgcolor: '#4285f4',
        '&:hover': {
          bgcolor: '#3367d6',
        },
      }}
    >
      {loading ? 'Signing in...' : 'Continue with Google'}
    </Button>
  );
}
